
export class SFConstants {
    public static S2C_LOGIN: string = "lgn";
    public static S2C_SOCIAL_LOGIN: string = "lgnp";
    public static C2S_LOGIN: string = "lgn";
    public static C2S_SOCIAL_LOGIN: string = "lgs";
    public static S2C_LOGIN_PLAY_NOW: string = "lpn";
    public static C2S_LOGIN_PLAY_NOW: string = "lpn";
    public static C2S_LOGIN_READY: string = "lgr";

    public static C2S_CREATE_AVATAR_SOCIAL: string = "cas";
    public static S2C_CREATE_AVATAR_SOCIAL: string = "cas";

    public static S2C_CHAT_PUNISHMENT: string = "cpu";

    public static S2C_REGISTER: string = "lre";
    public static C2S_REGISTER: string = "lre";

    public static S2C_CHANGE_PW: string = "lcp";
    public static C2S_CHANGE_PW: string = "lcp";

    public static S2C_LOST_PW: string = "llp";
    public static C2S_LOST_PW: string = "llp";

    public static S2C_CREATE_AVATAR: string = "lca";
    public static C2S_CREATE_AVATAR: string = "lca";

    public static S2C_VERSION_CHECK: string = "vck";
    public static C2S_VERSION_CHECK: string = "vck";

    public static C2S_CHANGE_LANGUAGE: string = "clg";

    public static S2C_SPECIAL_EVENT: string = "see";

    public static C2S_REPORT_PLAYER: string = "rpl";

    public static S2C_SPECIAL_OFFER_EVENT: string = "soe";

    //		User Data
    public static S2C_GET_CURRENCY: string = "gcu";
    public static S2C_GET_PLAYER_IDENTITY: string = "gpi";
    public static S2C_GET_XP: string = "gxp";
    public static S2C_GET_BASIC_DATA: string = "gbd";
    public static C2S_SET_PLAYER_CONFIG: string = "gpc";
    public static S2C_GET_PLAYER_CONFIG: string = "gpc";
    public static C2S_GET_PLAYER_AVATAR: string = "gpv";
    public static S2C_GET_PLAYER_AVATAR: string = "gpv";
    public static S2C_GET_PLAYER_PROFILE: string = "gpp";
    public static C2S_GET_PLAYER_PROFILE: string = "gpp";
    public static S2C_GET_DAILY_BONUS: string = "gdb";
    public static S2C_LEVELUP: string = "lvu";

    public static S2C_BROKE_PLAYER: string = "brp";

    // lobby/table

    public static C2S_TABLE_LIST: string = "tli";
    public static S2C_TABLE_LIST: string = "tli";

    public static C2S_TABLE_JOIN: string = "tjn";
    public static S2C_TABLE_JOIN: string = "tjn";

    public static C2S_TABLE_CREATE: string = "tcr";
    public static S2C_TABLE_CREATE: string = "tcr";

    public static C2S_LEAVE_TABLE: string = "tle";

    // shop

    public static C2S_SHOP_BUY: string = "sbu";
    public static S2C_SHOP_BUY: string = "sbu";
    public static C2S_INVENTORY_WEAR: string = "ivw";
    public static S2C_INVENTORY_WEAR: string = "ivw";

    // game
    public static C2S_GAME_SIT: string = "gsi";
    public static S2C_GAME_SIT: string = "gsi";
    public static C2S_GAME_STANDUP: string = "gsu";
    public static S2C_GAME_STANDUP: string = "gsu";

    public static S2C_GAME_LEVELUP: string = "glu";
    public static S2C_GAME_PLAYERJOIN: string = "gpj";
    public static S2C_GAME_PLAYERLEAVE: string = "gpl";
    public static C2S_GAME_ACTION: string = "gac";
    public static S2C_GAME_ACTION: string = "gac";
    public static S2C_GAME_START: string = "gst";
    public static S2C_GAME_PLAYERCARDS: string = "gpa";
    public static S2C_GAME_SETDEALER: string = "gsd";
    public static S2C_GAME_YOURTURN: string = "gyt";
    public static S2C_GAME_PLAYERTURN: string = "gpt";
    public static S2C_GAME_COMMUNITYCARDS: string = "gcc";
    public static S2C_GAME_NEXTROUND: string = "gnr";
    public static S2C_GAME_END: string = "gen";
    public static S2C_GAME_HANDCATEGORY: string = "ghc";
    public static C2S_GAME_GIFT: string = "ggg";
    public static S2C_GAME_GIFT: string = "ggg";
    public static S2C_GAME_ADD_FRIEND: string = "gaf";
    public static S2C_GAME_RESET: string = "grs";

    public static C2S_TABLE_CHAT: string = "tch";
    public static S2C_TABLE_CHAT: string = "tch";

    public static C2S_GAME_BOOK_SEAT: string = "gbs";
    public static S2C_GAME_BOOK_SEAT: string = "gbs";
    public static S2C_GAME_BOOKED_SEAT: string = "gbo";
    public static S2C_GAME_BOOK_RELEASED: string = "gbr";
    public static C2S_GAME_BOOK_RELEASE: string = "gbr";

    // rabbit cam
    public static C2S_GAME_RABBITCAM: string = "grc";
    public static S2C_GAME_RABBITCAM_PLAY: string = "grp";
    public static S2C_GAME_SHOW_RABBIT_CAM_BUTTON: string = "grb";
    public static S2C_GAME_HIDE_RABBIT_CAM_BUTTON: string = "grh";

    // tournament/joust
    public static C2S_JOUST_LIST: string = "jli";
    public static S2C_JOUST_LIST: string = "jli";
    public static C2S_JOUST_REGISTER: string = "jre";
    public static S2C_JOUST_REGISTER: string = "jre";
    public static C2S_JOUST_UNREGISTER: string = "jur";
    public static S2C_JOUST_UNREGISTER: string = "jur";
    public static C2S_JOUSTTABLE_LIST: string = "jts";
    public static S2C_JOUSTTABLE_LIST: string = "jts";
    public static C2S_JOUSTTABLE_JOIN: string = "jtj";
    public static S2C_JOUSTTABLE_JOIN: string = "jtj";
    public static C2S_JOUST_JOIN: string = "jjn";
    public static S2C_JOUST_JOIN: string = "jjn";
    public static S2C_JOUST_INVITATION: string = "jji";
    public static S2C_JOUST_NEXT: string = "jnx";
    public static S2C_JOUST_END: string = "jen";
    public static S2C_JOUST_TABLEEND: string = "jte";
    public static C2S_JOUST_ZOMBIE: string = "jzo";
    public static S2C_JOUST_ZOMBIE: string = "jzo";
    public static S2C_JOUST_SETBLIND: string = "jsb";
    public static C2S_JOUST_INFO: string = "jio";
    public static S2C_JOUST_INFO: string = "jio";
    public static C2S_REBUY_IN: string = "jrb";
    public static S2C_REBUY_IN: string = "jrb";

    //Sit n Go
    public static C2S_SITNGO_LIST: string = "sli";
    public static S2C_SITNGO_LIST: string = "sli";
    public static C2S_SITNGO_REGISTER: string = "sre";
    public static S2C_SITNGO_REGISTER: string = "sre";
    public static C2S_SITNGO_UNREGISTER: string = "sur";
    public static S2C_SITNGO_UNREGISTER: string = "sur";
    public static C2S_SITNGO_JOIN: string = "sjn";
    public static S2C_SITNGO_JOIN: string = "sjn";
    public static S2C_SITNGO_INVITATION: string = "sin";
    public static C2S_SITNGO_ZOMBIE: string = "szo";
    public static S2C_SITNGO_ZOMBIE: string = "szo";
    public static S2C_SITNGO_END: string = "sen";
    public static S2C_SITNGO_SETBLIND: string = "ssb";
    public static C2S_SITNGO_SPECTATE: string = "ssp";
    public static S2C_SITNGO_SPECTATE: string = "ssp";

    // Slotmachine
    public static S2C_START_SLOTMACHINE: string = "ssm";
    public static C2S_START_SLOTMACHINE: string = "ssm";
    public static C2S_STOPP_SLOTMACHINE: string = "css";

    // booster
    public static C2S_BOOSTER_BUY: string = "bbu";
    public static S2C_BOOSTER_BUY: string = "bbu";

    //ranking
    public static C2S_RANKING_LIST: string = "ral";
    public static S2C_RANKING_LIST: string = "ral";
    public static C2S_JOUSTRANKING_LIST: string = "rjl";
    public static S2C_JOUSTRANKING_LIST: string = "rjl";
    public static C2S_HALL_OF_FAME: string = "rhf";
    public static S2C_HALL_OF_FAME: string = "rhf";
    public static S2C_RANKING_AVATAR_LIST: string = "raa";
    public static C2S_RANKING_AVATAR_LIST: string = "raa";
    public static S2C_RANKING_TOPAVATAR: string = "rta";
    public static C2S_RANKING_TOPAVATAR: string = "rta";

    //achievements
    public static S2C_ACHIEVEMENT_REACHED: string = "are";
    public static S2C_ACHIEVEMENT_LIST: string = "ali";
    public static C2S_ACHIEVEMENT_LIST: string = "ali";
    //various
    public static C2S_VARIOUS_GIVECHIPS: string = "vgc";
    public static S2C_VARIOUS_GIVECHIPS: string = "vgc";

    //email verification
    public static S2C_EMAIL_VERIFICATION: string = "emv";
    public static C2S_EMAIL_VERIFICATION: string = "emv";
    public static S2C_EMAIL_CONFIRMED: string = "emc";
    public static C2S_EMAIL_SET: string = "emb";

    //Buddy
    public static S2C_SOCIAL_BUDDIES: string = "sbs";
    public static C2S_SOCIAL_BUDDIES: string = "sbs";
    public static S2C_BUDDY_AVATARS: string = "bga";
    public static C2S_BUDDY_INGAME: string = "big";
    public static S2C_BUDDY_INGAME: string = "big";
    public static C2S_BUDDY_ONLINESTATE: string = "bos";
    public static S2C_BUDDY_ONLINESTATE: string = "bos";

    public static C2S_INVITE_FRIEND: string = "cif";
    public static S2C_INVITE_FRIEND: string = "cif";

    public static C2S_JOIN_FRIENDTABLE: string = "cjf";
    public static S2C_JOIN_FRIENDTABLE: string = "cjf";

    public static C2S_SHOW_FEATURETEASER: string = "fst";
    public static S2C_SHOW_FEATURETEASER: string = "fst";

    //Bonus Events
    public static S2C_BONUS_EVENT_XP: string = "bex";
    public static S2C_STARTER_PACKAGE_TEASER: string = "spt";
    public static C2S_BUY_STARTER_PACKAGE: string = "spb";
    public static S2C_BOUGHT_STARTER_PACKAGE: string = "spb";

    //Feedback
    public static C2S_FEEDBACK: string = "gfb";

    //Tutorial
    public static C2S_TUTORIAL_STEP: string = "tst";
    public static S2C_TUTORIAL_STEP: string = "tst";
    public static C2S_TUTORIAL_CANCLE: string = "tcl";
    public static C2S_TUTORIAL_START: string = "tts";
    public static S2C_TUTORIAL_START: string = "tts";

    constructor() {
    }
}
